import {FeatureCollection, Point as GeoPoint} from "geojson"
import {TXY} from "@ui/api/features"
import pointService from "@ui/services/features/PointService"
import {LayerId} from "@ui/services/features"
import {Feature, TFeatureConstructorParams} from "./feature"

type TGetPointsXY = (xy: TXY) => Promise<FeatureCollection<GeoPoint>>

type TPointConstructorParams = {
  id: LayerId              // id слоя
  get: TGetPointsXY         // метод загрузки данных с geo точками
} & TFeatureConstructorParams

export class Point extends Feature {
  id: LayerId
  get: TGetPointsXY

  constructor(params: TPointConstructorParams) {
    super(params)
    this.id = params.id
    this.get = params.get
  }

  async load(xy: TXY): Promise<void> {
    const points = await this.get(xy)
    pointService.addPoints(this.id, points)
  }

  toggle(isVisible: boolean) {
    pointService.toggleLayer(this.id, isVisible)
  }
}
